import { Injectable } from '@angular/core';

// Run 

// ionic cordova plugin add cordova-plugin-advanced-http

// npm install @ionic-native/http

// In app.module.ts after last import add

// import { HTTP } from '@ionic-native/http/ngx';

// import { HttpClientModule } from '@angular/common/http';

// and include 

// HTTP

// in providers array and

// HttpClientModule

// in imports array

import { Platform } from '@ionic/angular';
// import { HTTP } from '@ionic-native/http/ngx';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map, takeLast } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
    // 'Content-Type': 'application/json',
    // 'Accept': 'text/html',
    // 'Access-Control-Allow-Origin':'*'
  }),
  // responseType: 'text' as 'json'
};

@Injectable({
  providedIn: 'root'
})
export class RestService {

  http: any;
  msg = "Rest Available";

  httpN: any;

  constructor(
  private platform: Platform,
  // public httpN: HTTP,
  public httpC: HttpClient
  ){
  }










  test()
  {
    return this.msg
  }










  cordova(){
    if(this.platform.is('cordova')){
      this.http = this.httpN;
      this.http.setDataSerializer('json')
      return true;
    } else {
      this.http = this.httpC;
      return false;
    }
  }










  get(base: string, id: string, op?: string): Promise<any>
  {
    if(this.cordova()){
      return this.http.get(base+(op || '/')+id, {}, this.headerOpt())
    } else {
      return this.http.get(`${base}${op || '/'}${id}`, httpOptions)
      .pipe
      (
        takeLast(1),
        map(this.extractData),
        catchError(this.handleError)
      )
      .toPromise()
    }
  }



  post (base: string,  id: string, data:any): Promise<any>
  {
    if(this.cordova()){
      return this.http.post(`${base}/${id}`, data, this.headerOpt())
    } else {
      return this.http.post(`${base}/${id}`, JSON.stringify(data), httpOptions)
      .pipe
      (
        takeLast(1),
        map(this.extractData),
        catchError(this.handleError)
      )
      .toPromise()
    }
  }



  update(base: string, id: string, data: any): Promise<any>
  {
    if(this.cordova()){
      return this.http.put(`${base}/${id}`, data, this.headerOpt())
    } else {
      return this.http.put(`${base}/${id}`, JSON.stringify(data), httpOptions)
      .pipe
      (
        takeLast(1),
        map(this.extractData),
        catchError(this.handleError)
      )
      .toPromise()
    }
  }



  remove(base: string, id: string): Promise<{}>
  {
    if(this.cordova()){
      return this.http.delete(`${base}/${id}`, {}, this.headerOpt())
    } else {
      return this.http.delete(`${base}/${id}`, httpOptions)
      .pipe
      (
        takeLast(1),
        catchError(this.handleError)
      )
      .toPromise()
    }
  }



  private handleError(error: HttpErrorResponse)
  {
    if (error.error instanceof ErrorEvent)
    {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else
    {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.')
  }



  private extractData(res: Response) {
    let body = {
      data: JSON.stringify(res)
    }
    return body || { }
  }


  headerOpt() {
    return {
      // "Content-Type": "application/json",
      // "Access-Control-Allow-Origin":"*"
    }
  }






}
